import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import ScoreCalculationConfiguration from "Administrator/commonComponents/GradingSetupV2/routes/ScoreCalculationConfiguration";
import GradingMethodology from "Administrator/commonComponents/GradingSetupV2/routes/GradingMethodology";
import GradingCategoriesConfiguration from "Administrator/commonComponents/GradingSetupV2/routes/GradingCategoriesConfiguration";
import GradeScales from "Administrator/commonComponents/GradingSetupV2/routes/GradeScales";
import AdminFinalGradeSetup from "Administrator/commonComponents/GradingSetupV2/routes/AdminFinalGradeSetup";
import StandardCalculationConfiguration from "Administrator/commonComponents/GradingSetupV2/routes/StandardCalculationConfiguration";
import GradeScalesAndDescriptors from "Administrator/commonComponents/GradingSetupV2/routes/GradeScalesAndDescriptors";
import VisibilitySettings from "Administrator/commonComponents/GradingSetupV2/routes/VisibilitySettings";
import AssessmentTypeSettings from "Administrator/commonComponents/GradingSetup/routes/AssessmentTypes";
import MYPCriteriaBasedGrading from "Administrator/commonComponents/GradingSetupV2/routes/MYPCriteriaBasedGrading";
import ContinuumGradingSetup from "Administrator/commonComponents/GradingSetupV2/routes/ContinuumGradingSetup";
import LearningGoalsGrading from "Administrator/commonComponents/GradingSetupV2/routes/LearningGoalsGrading";
import CreditsSetup from "Administrator/commonComponents/GradingSetupV2/routes/CreditsSetup";
import GpaSetup from "Administrator/commonComponents/GradingSetupV2/routes/GpaSetup";
import GpaAndCredits from "Administrator/commonComponents/GradingSetupV2/routes/GpaAndCredits";
import ScoreGradeAggregation from "Administrator/commonComponents/GradingSetupV2/routes/ScoreGradeAggregation";
import ProjectProgressIndicators from "Login/routes/Administrator/commonComponents/ProjectProgressIndicators";

export default store => ({
  path: "grading",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    GradingMethodology(store),
    GradeScales(store),
    AdminFinalGradeSetup(store),
    CreditsSetup(store),
    GpaSetup(store),
    GpaAndCredits(store),
    ScoreGradeAggregation(store),
    GradingCategoriesConfiguration(store),
    ScoreCalculationConfiguration(store),
    StandardCalculationConfiguration(store),
    GradeScalesAndDescriptors(store),
    VisibilitySettings(store),
    AssessmentTypeSettings(store),
    MYPCriteriaBasedGrading(store),
    ContinuumGradingSetup(store),
    LearningGoalsGrading(store),
    ProjectProgressIndicators(store),
  ],
});
